import React from "react"
import data from "../yourdata"

const Skills = () => {
  return (
    <div className="section">
      <div className="container">
        <div className="skills-container">
          {console.log(data)}
          <h1>Experience</h1>
          <div className="skills-grid">
            {data.skills.map((skill, index) => (
              <div className="skill" key={index}>
                <img src={skill.img} alt=""/>
                <b><p className="company">{skill.company}<div className="tenure">{skill.tenure}</div></p></b>
                <div className="para" style={{fontSize: 14+ "px"}}>{skill.para}</div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  )
}

export default Skills
